import React, { useContext, useRef, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import Select from "react-select";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { SubmitBtn } from "../../Components/InputElements";
import { currentDateAndTime, isNumeric, isNumericOnly } from "../../Constants/constants";
import { decodeData } from "../../Constants/constants";
import { useLocation } from "react-router-dom";
import TooltipComponent from "../../Components/TooltipComponent";
const LeaveTemplateSettings = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [loading, setLoading] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [leaveTypeId, setLeaveTypeId] = useState("");
    const [leaveOptions, setLeaveOptions] = useState([]);
    const [errors, setErrors] = useState({})
    const monthOptions = [
        { value: 1, label: "1 Month" },
        { value: 2, label: "2 Month" },
        { value: 3, label: "3 Month" },
        { value: 4, label: "4 Month" },
        { value: 5, label: "5 Month" },
        { value: 6, label: "6 Month" },
        { value: 7, label: "7 Month" },
        { value: 8, label: "8 Month" },
        { value: 9, label: "9 Month" },
        { value: 10, label: "10 Month" },
        { value: 11, label: "11 Month" },
        { value: 12, label: "12 Month" },
    ];
    const payrollCycleOptions = [
        { value: 1, label: "Payroll Cycle 1" },
        { value: 2, label: "Payroll Cycle 2" },
        { value: 3, label: "Payroll Cycle 3" },
    ];
    const [formData, setFormData] = useState({
        leave_template_setting_id: 0,
        leaveType: null,
        accrualFrom: null,
        cutOffProRate: null,
        fixCutOffProRate: '',
        daysBeforeLeaveApply: "0",
        leaveAccrual: null,
        dayOfLeaveAccrual: null,
        balanceCarriedForward: null,
        balanceCarriedForwardToBe: null,
        balanceCarriedForwardNumber: "",
        paidLeave: null,
        leave_available_in_notice_period: null,
        encashed_leave_on_fnf: null,
        exceedMaxCapLeave: null,
        excessLeaveToBe: null,
        eligibilityOfLeaves: null,
        eligibilityOfAccrueLeaves: null,
        leaveApplicableAfter: "",
        negativeLeave: null,
        negativeLeaveToBe: '0',
        // applyLeaveOnWeeklyOffOrHoliday: null,
        futureLeave: null,
        futureDaysToApplyLeave: null,
        backDateLeave: null,
        backDaysToApplyLeave: null,
        // leaveAfterSalary: null,
        // daysToApplyLeaveAfterSalary: null,
        halfDayLeave: null,
        considerAllDaysAsLeave: null,
        excludeWeeklyOff: "0",
        excludeHoliday: "0",
        
        minConsecutiveLeaveDays: '0',
        maxConsecutiveLeaveDays: '0',
        separatedWeeklyOffOrHolidayConsecutive: null,
        // separatedHolidayConsecutive: null,
        documentMandatory: null,
        commentMandatory: null,
        clubbedLeave: null,
        nearestAccrualUnit:null
        
    });

    const accrualFromRef = useRef(null);
    const leaveAccrualRef = useRef(null);
    const paidLeaveRef = useRef(null);
    const balanceCarriedForwardToBeRef = useRef(null);
    const balanceCarriedForwardNumberRef = useRef(null);
    const exceedMaxCapLeaveRef = useRef(null);
    const excessLeaveToBeRef = useRef(null);
    const encashed_leave_on_fnfRef = useRef(null);
    const leave_available_in_notice_periodRef = useRef(null);
    const eligibilityOfLeavesRef = useRef(null);
    const leaveApplicableAfterRef = useRef(null);
    const eligibilityOfAccrueLeavesRef = useRef(null);
    const cutOffProRateRef = useRef(null);
    const fixCutOffProRateRef = useRef(null);
    const daysBeforeLeaveApplyRef = useRef(null);
    const futureLeaveRef = useRef(null);
    const futureDaysToApplyLeaveRef = useRef(null);
    const backDateLeaveRef = useRef(null);
    const backDaysToApplyLeaveRef = useRef(null);
    const halfDayLeaveRef = useRef(null);
    const considerAllDaysAsLeaveRef = useRef(null);
    const minConsecutiveLeaveDaysRef = useRef(null);
    const maxConsecutiveLeaveDaysRef = useRef(null);
    const documentMandatoryRef = useRef(null);
    const commentMandatoryRef = useRef(null);
    // const excludeWeeklyOffRef = useRef(null);
    // const excludeHolidayRef = useRef(null);

    useEffect(() => {
        if (errors?.balanceCarriedForwardToBe) {
            balanceCarriedForwardToBeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            balanceCarriedForwardToBeRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.balanceCarriedForwardNumber) {
            balanceCarriedForwardNumberRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            balanceCarriedForwardNumberRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.accrualFrom) {
            accrualFromRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            accrualFromRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.leaveAccrual) {
            leaveAccrualRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            leaveAccrualRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.paidLeave) {
            paidLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            paidLeaveRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.exceedMaxCapLeave) {
            exceedMaxCapLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            exceedMaxCapLeaveRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.excessLeaveToBe) {
            excessLeaveToBeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            excessLeaveToBeRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.encashed_leave_on_fnf) {
            encashed_leave_on_fnfRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            encashed_leave_on_fnfRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.leave_available_in_notice_period) {
            leave_available_in_notice_periodRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            leave_available_in_notice_periodRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.eligibilityOfLeaves) {
            eligibilityOfLeavesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            eligibilityOfLeavesRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.leaveApplicableAfter) {
            leaveApplicableAfterRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (errors?.eligibilityOfAccrueLeaves) {
            eligibilityOfAccrueLeavesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            eligibilityOfAccrueLeavesRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.cutOffProRate) {
            cutOffProRateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            cutOffProRateRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.fixCutOffProRate) {
            fixCutOffProRateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            fixCutOffProRateRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.daysBeforeLeaveApply) {
            daysBeforeLeaveApplyRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            daysBeforeLeaveApplyRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.futureLeave) {
            futureLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            futureLeaveRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.futureDaysToApplyLeave) {
            futureDaysToApplyLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            futureDaysToApplyLeaveRef.current?.focus();
        }
        if (errors?.backDateLeave) {
            backDateLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            backDateLeaveRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.backDaysToApplyLeave) {
            backDaysToApplyLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            backDaysToApplyLeaveRef.current?.focus();
        }
        if (errors?.halfDayLeave) {
            halfDayLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            halfDayLeaveRef.current?.focus();
        }
        if (errors?.considerAllDaysAsLeave) {
            considerAllDaysAsLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            considerAllDaysAsLeaveRef.current?.focus();
        }
        if (errors?.minConsecutiveLeaveDays) {
            minConsecutiveLeaveDaysRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            minConsecutiveLeaveDaysRef.current?.focus();
        }
        if (errors?.maxConsecutiveLeaveDays) {
            maxConsecutiveLeaveDaysRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            maxConsecutiveLeaveDaysRef.current?.focus();
        }
        if (errors?.documentMandatory) {
            documentMandatoryRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            documentMandatoryRef.current?.focus();
        }
        if (errors?.commentMandatory) {
            commentMandatoryRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            commentMandatoryRef.current?.focus();
        }
        // if (errors?.excludeWeeklyOff) {
        //     excludeWeeklyOffRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     excludeWeeklyOffRef.current?.focus();
        // }
        // if (errors?.excludeHoliday) {
        //     excludeHolidayRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     excludeHolidayRef.current?.focus();
        // }
        // if(errors?.backDaysToApplyLeaveRef) {
        //     backDaysToApplyLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center'});
        //     backDaysToApplyLeaveRef.current?.focus();
        // }
    }, [errors]);


    // const getLeaveTypeList = (typelist = 1) => {
    //     const headers = apiHeaderJSON;
    //     axios
    //         .get(`${apiURL}Masters/GetLeaveTypeList`, {
    //             params: { typelist: typelist },
    //             headers,
    //         })
    //         .then((response) => {
    //             console.log("getLeaveTypeList=>>", response);
    //             var data = response.data;
    //             let temp;
    //             if (response.data.success === true) {
    //                 temp = data?.data?.map((val) => {
    //                     return { value: val?.leave_type_id, label: val?.leave_type_name };
    //                 });
    //                 setLeaveOptions(temp);
    //             }
    //             console.log("temp", temp);
    //         });
    // };

    const getLeaveTypeList = (typelist = 0) => {
        const headers = apiHeaderJSON;
        axios
            .get(`${apiURL}Masters/GetLeaveTypeListSandbox`, {
                params: { typelist: typelist },
                headers,
            })
            .then((response) => {
                // console.log("getLeaveTypeList=>>", response);
                var data = response.data;
                let temp;
                if (response.data.success === true) {
                    temp = data?.data?.map((val) => {
                        return { value: val?.leave_type_id, label: val?.leave_type_name };
                    });
                    setLeaveOptions(temp);
                }
                // console.log("temp", temp);
            });
    };

    useEffect(() => {
        getLeaveTypeList(0);
    }, []);

    const getLeaveTemplateSettingInfo = () => {
        const headers = apiHeaderJSON;
        setLoading(true);
        // console.log("formData?.leaveType.value", leaveTypeId);
        axios
            .get(
                `${apiURL}Masters/GetLeaveTemplateSetting?leave_type_id=${leaveTypeId}`,
                { headers }
            )
            .then((response) => {
                const { success } = response.data;
                // console.log("getLeaveTemplateSettingInfo ~ response", response);
                if (success === true) {
                    let data = response.data;
                    // console.log(
                    //     "data?.result[0]?.leave_type_id",
                    //     data?.result[0]?.leave_type_id
                    // );
                    setErrors({});
                    setFormData({
                        leave_template_setting_id: data?.result[0]?.leave_template_setting_id || 0,
                        leaveType: data?.result[0]?.leave_type_id || null,
                        accrualFrom: data?.result[0]?.leave_accrual_type || null,
                        cutOffProRate: data?.result[0]?.pro_rate_leave_balance || null,
                        fixCutOffProRate: data?.result[0]?.fixed_cut_off_for_pro_rate || '',
                        daysBeforeLeaveApply: data?.result[0]?.how_many_days_before_apply_leave || '0',
                        leaveAccrual: data?.result[0]?.run_leave_accrual || null,
                        dayOfLeaveAccrual: data?.result[0]?.run_leave_accrual_end_beginnig || null,
                        balanceCarriedForward: data?.result[0]?.carry_forword_balance || null,
                        balanceCarriedForwardToBe: data?.result[0]?.carry_forwrod_type || null,
                        balanceCarriedForwardNumber: data?.result[0]?.carry_forwrod_type_number || null,
                        paidLeave: data?.result[0]?.is_paid_leave || null,
                        encashed_leave_on_fnf: data?.result[0]?.encashed_leave_on_fnf || null,
                        leave_available_in_notice_period: data?.result[0]?.leave_available_in_notice_period || null,
                        exceedMaxCapLeave: data?.result[0]?.leave_exceeding_max_cap_before_year_end || null,
                        excessLeaveToBe: data?.result[0]?.if_exceeded_then_how_to_be_encashed || null,
                        eligibilityOfLeaves: data?.result[0]?.emp_eligible_for_leave || null,
                        eligibilityOfAccrueLeaves: data?.result[0]?.emp_eligible_for_accrue_leave || null,
                        leaveApplicableAfter: parseInt(data?.result[0]?.emp_eligible_for_leave_after) || "",
                        negativeLeave: data?.result[0]?.emp_allow_negative_balance || null,
                        negativeLeaveToBe: data?.result[0]?.emp_allow_negative_balance_in_day || '0',
                        futureLeave: data?.result[0]?.emp_can_apply_future_leave || null,
                        futureDaysToApplyLeave: data?.result[0]?.emp_can_apply_future_leave_days || null,
                        backDateLeave: data?.result[0]?.emp_can_apply_back_dated_leave || null,
                        backDaysToApplyLeave: data?.result[0]?.emp_can_apply_back_dated_leave_days || null,
                        halfDayLeave: data?.result[0]?.half_day_allowed || null,
                        considerAllDaysAsLeave: data?.result[0]?.consider_all_days_as_leave || null,
                        excludeWeeklyOff: data?.result[0]?.exclude_week_off_in_sandwich || "0",
                        excludeHoliday: data?.result[0]?.exclude_holiday_in_sandwich || "0",
                        minConsecutiveLeaveDays: data?.result[0]?.minimum_consecutive_leave_allowed || '0',
                        maxConsecutiveLeaveDays: data?.result[0]?.maximum_consecutive_leave_allowed || '0',
                        separatedWeeklyOffOrHolidayConsecutive: data?.result[0]
                                ?.leave_separated_by_week_off_holiday_consider_as_consecutive || null,
                        documentMandatory: data?.result[0]?.document_mandatory || null,
                        commentMandatory:
                            data?.result[0]?.madatory_comment_while_cancel || null,
                        clubbedLeave: data?.result[0]?.can_be_clubbed || null,
                        nearestAccrualUnit:data?.result[0]?.round_off_leave_accrual || "0"
                    });
                } else if (success === false) {
                    setFormData({
                        leaveType: leaveTypeId,
                        leaveAccrual: null,
                        accrualFrom: null,
                        cutOffProRate: null,
                        fixCutOffProRate: "",
                        daysBeforeLeaveApply: "0",
                        dayOfLeaveAccrual: null,
                        balanceCarriedForward: null,
                        balanceCarriedForwardToBe: null,
                        balanceCarriedForwardNumber: '',
                        exceedMaxCapLeave: null,
                        excessLeaveToBe: null,
                        eligibilityOfLeaves: null,
                        eligibilityOfAccrueLeaves: null,
                        leaveApplicableAfter: "",
                        negativeLeave: null,
                        negativeLeaveToBe: '0',
                        futureLeave: null,
                        futureDaysToApplyLeave: null,
                        backDateLeave: null,
                        backDaysToApplyLeave: "0",
                        halfDayLeave: null,
                        considerAllDaysAsLeave: null,
                        excludeWeeklyOff: "0",
                        excludeHoliday: "0",
                        paidLeave: null,
                        minConsecutiveLeaveDays: "0",
                        maxConsecutiveLeaveDays: "0",
                        separatedWeeklyOffOrHolidayConsecutive: null,
                        documentMandatory: null,
                        commentMandatory: null,
                        clubbedLeave: null,
                        nearestAccrualUnit:'0'
                    });
                }
            });
        setLoading(false);
    };

    useEffect(() => {
        if (formData?.leaveType) {
            getLeaveTemplateSettingInfo();
        }
    }, [formData?.leaveType]);

    const validateForm = () => {
        let errors = {}
        if (!formData?.leaveType) {
            errors.leaveType = "Leave Type is required!"
          return errors;
        }
        if (!formData?.balanceCarriedForwardToBe) {
            errors.balanceCarriedForwardToBe = "Yearly carried forward balance is required!"
          return errors;
        } 
        if (formData?.balanceCarriedForwardToBe === "3" && (!formData?.balanceCarriedForwardNumber || formData?.balanceCarriedForwardNumber == "0")) {
            // console.log(formData?.balanceCarriedForwardToBe === "3", formData?.balanceCarriedForwardNumber)
            errors.balanceCarriedForwardNumber = formData?.balanceCarriedForwardNumber == "0" ? "Max Cap can not be zero!" : "Max Cap number is required!"
          return errors;
        }
        // console.log("formData?.accrualFrom",formData?.accrualFrom);
        if (!formData?.accrualFrom) {
            errors.accrualFrom = "This is required"
            return errors;
        }
        if (!formData?.leaveAccrual) {
            errors.leaveAccrual = "Leave accrual is required"
          return errors;
        }
        if (!formData?.paidLeave) {
            errors.paidLeave = "This is required"
          return errors;
        }
        if (formData?.balanceCarriedForwardToBe === "3" && !formData?.exceedMaxCapLeave) {
            console.log("Exceeding the maximum capping of the leave is required");
            errors.exceedMaxCapLeave = "Exceeding the maximum capping of the leave is required"
          return errors;
       }
        if (formData?.balanceCarriedForwardToBe === "3" && formData?.exceedMaxCapLeave === "2" && !formData?.excessLeaveToBe) {
            errors.excessLeaveToBe = "Leave to be encashed is required"
          return errors;
        }
        if (!formData?.encashed_leave_on_fnf) {
            errors.encashed_leave_on_fnf = "This is required"
          return errors;
        }
        if (!formData?.leave_available_in_notice_period) {
            errors.leave_available_in_notice_period = "This is required"
          return errors;
        }
        if (!formData?.eligibilityOfLeaves) {
            errors.eligibilityOfLeaves = "This is required"
          return errors;
        }
        if (formData?.eligibilityOfLeaves === "3" && !formData?.leaveApplicableAfter) {
            errors.leaveApplicableAfter = "Please select month!"
            return errors;
        }
        if ((formData?.eligibilityOfLeaves === "2" || formData?.eligibilityOfLeaves === "3") && !formData?.eligibilityOfAccrueLeaves) {
            errors.eligibilityOfAccrueLeaves = "Please select allow leave accrue or not!"
            return errors;
        }
        if (!formData?.cutOffProRate) {
            errors.cutOffProRate = "This is required"
          return errors;
        }
        if (formData?.cutOffProRate==="1" && !formData?.fixCutOffProRate) {
            errors.fixCutOffProRate = "This is required"
          return errors;
        }
        if (!formData?.daysBeforeLeaveApply) {
            errors.daysBeforeLeaveApply = "This is required"
          return errors;
        }
        if (!formData?.futureLeave) {
            errors.futureLeave = "This is required!";
          return errors;
        }
        if (formData?.futureLeave === "1" && (formData?.futureDaysToApplyLeave == "0" || !formData?.futureDaysToApplyLeave)) {
            errors.futureDaysToApplyLeave = formData?.futureDaysToApplyLeave == "0" ? "Future leave day can not be zero" : "Future leave day is required!"
          return errors;
        }
        if (!formData?.backDateLeave) {
            errors.backDateLeave = "This is required!";
          return errors;
        }
        if (formData?.backDateLeave === "1" && (formData?.backDaysToApplyLeave == "0" || !formData?.backDaysToApplyLeave)) {
            errors.backDaysToApplyLeave = formData?.backDaysToApplyLeave == "0" ? "Back dated leave day can not be zero" : "Back Dated leave day is required!"
            return errors;
        }
        if (!formData?.halfDayLeave) {
            errors.halfDayLeave = "This is required!";
          return errors;
        }
        if (!formData?.considerAllDaysAsLeave) {
            errors.considerAllDaysAsLeave = "This is required!";
          return errors;
        }
        if (formData?.minConsecutiveLeaveDays == "0" || !formData?.minConsecutiveLeaveDays) {
            errors.minConsecutiveLeaveDays = formData?.minConsecutiveLeaveDays == "0" ? " Min Number of consecutive leave days can not be zero" : " Min Number of consecutive leave day is required!"
          return errors;
        }
            if (formData?.maxConsecutiveLeaveDays == "0" || !formData?.maxConsecutiveLeaveDays) {
                errors.maxConsecutiveLeaveDays = formData?.maxConsecutiveLeaveDays == "0" ? " Max Number of consecutive leave days can not be zero" : " Max Number of consecutive leave day is required!"
            return errors;
        }
        if (!formData?.documentMandatory) {
            errors.documentMandatory = "This is required!";
          return errors;
        }
        if (!formData?.commentMandatory) {
            errors.commentMandatory = "This is required!";
          return errors;
        }
        // if (formData?.formData?.considerAllDaysAsLeave === "0" && !formData?.excludeWeeklyOff) {
        //     errors.excludeWeeklyOff = "This is required!";
        //   return errors;
        // }
        // if (formData?.formData?.considerAllDaysAsLeave === "0" && !formData?.excludeHoliday) {
        //     errors.excludeHoliday = "This is required!";
        //   return errors;
        // }

        
        
        
        
  // ----------------------------------------------------------------------------------------------------------

    //    console.log("formData?.cutOffProRate",formData?.cutOffProRate);
    //    console.log("formData?.fixCutOffProRate",formData?.fixCutOffProRate);
        // console.log("formData?.daysBeforeLeaveApply",formData?.daysBeforeLeaveApply, typeof formData?.daysBeforeLeaveApply);
        
        
        

        return errors;

    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = validateForm();
        console.error("errors 1", errors);
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            console.error("errors 2", errors);
            return;
        }

        const headers = apiHeaderJSON;
        setPostLoading(true);
        const leaveTemlateFormData ={
            ...formData,
            date:currentDateAndTime()
        }
        // console.log("handleSubmit ~ form Data =======>>>", leaveTemlateFormData);
        axios
            .post(`${apiURL}Masters/CreateLeaveTemplateSetting`, leaveTemlateFormData, {
                headers,
            })
            .then((response) => {
                const { success } = response.data;
                // console.log("handleSubmit ~ response =======>>>", response);

                if (success === true) {
                    
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Optional: You can perform any action here after OK is clicked
                            setPostLoading(false);
                            getLeaveTemplateSettingInfo();  // Call your function after the alert is closed
                        }
                    });
                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,  // Show OK button
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Optional: Action after the OK button is clicked
                            setPostLoading(false);
                        }
                    });
                }
            });
    };

    const handleFormData = (name, value) => {
        if (name === "eligibilityOfLeaves" && value !== "3") {
            setFormData({ ...formData, [name]: value, leaveApplicableAfter: null });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "balanceCarriedForward") {
            setFormData({
                ...formData,
                [name]: value,
                balanceCarriedForwardToBe: null,
            });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "balanceCarriedForwardToBe" && value === "3") {
            setFormData({
                ...formData,
                [name]: value,
                balanceCarriedForwardNumber: "0",
            });
            // setErrors({ ...errors, [name]: "", balanceCarriedForwardNumber: "" });
        } 
        else if (name === "paidLeave" && value === "0") {
            setFormData({ ...formData, [name]: value, exceedMaxCapLeave: "1",encashed_leave_on_fnf: "0" });
            // setErrors({ ...errors, [name]: "" });
        } 
        else if (name === "exceedMaxCapLeave" && value === "1") {
            setFormData({ ...formData, [name]: value, excessLeaveToBe: null });
            // setErrors({ ...errors, [name]: "" });
        } 
        else if (name === "negativeLeave" && value !== "0") {
            setFormData({ ...formData, [name]: value, negativeLeaveToBe: null });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "futureLeave" && value !== "1") {
            setFormData({ ...formData, [name]: value, futureDaysToApplyLeave: null });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "backDateLeave" && value === "0") {
            setFormData({ ...formData, [name]: value, backDaysToApplyLeave: null });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "halfDayLeave" && value === "1") {
            setFormData({ ...formData, [name]: value, minConsecutiveLeaveDays: "0.5" });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "halfDayLeave" && value === "0") {
            setFormData({ ...formData, [name]: value, minConsecutiveLeaveDays: "1" });
            // setErrors({ ...errors, [name]: "" });
        } else if (name === "considerAllDaysAsLeave" && value === "1") {
            setFormData({ ...formData, [name]: value, excludeWeeklyOff: "0", excludeHoliday: "0" });
            // setErrors({ ...errors, [name]: "" });
        } else {
            // console.log("handleFormData", name, value);
            setFormData({ ...formData, [name]: value });
            // setErrors({ ...errors, [name]: "" });
        }
        setErrors({});
    };

    const handleNumbers = (name, value) => {
        // console.log("isNumeric(value)",isNumeric(value),name, value);
        if (isNumeric(value)) {
            // console.log("isNumeric(value)", isNumeric(value));
            setFormData({ ...formData, [name]: value });
            // setErrors({ ...errors, [name]: "" });
        }
        setErrors({});
    }

    // console.log("LeaveTemplateSettings ~ formData", formData);

    return (
        <div>
            {!loading ? (
                <div class="main-content">
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Leave Template Settings`} primary={`Home`} />
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">
                                        Leave Template Settings
                                    </h4>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12">
                                            <form onSubmit={handleSubmit} className="row settings-form">
                                                {/* leave type setting  */}
                                                <div className="col-md-6 mt-3">
                                                    <label htmlFor="leave_gender" className="form-label">
                                                        Leave Type
                                                    </label>
                                                    <Select
                                                        id="leave_type"
                                                        name="leave_type"
                                                        value={leaveOptions?.find(
                                                            (val) => val?.value === formData?.leaveType
                                                        )}
                                                       
                                                        onChange={(selectedOption) => {
                                                            setFormData({
                                                                ...formData,
                                                                leaveType: selectedOption?.value,
                                                            });
                                                            setLeaveTypeId(selectedOption?.value);
                                                        }}
                                                        options={leaveOptions}
                                                        placeholder="Select Leave Type"
                                                        required
                                                    />
                                                    <div>{errors?.leaveType ? errors?.leaveType : null}</div>
                                                </div>
                                                {/* balance carried forward Setting */}
                                                <div className="col-md-6 mt-4 mb-4 settings-section">
                                                    <label>
                                                        How do you want to carried forward balance end of the year cycle?
                                                    </label>
                                                    <br />
                                                    {/* <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_carried_monthly"
                                                            name="leave_carried_monthly"
                                                            value="monthly"
                                                            checked={
                                                                formData?.balanceCarriedForward === "monthly"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "balanceCarriedForward",
                                                                    "monthly"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_carried_monthly"
                                                            className="form-check-label"
                                                        >
                                                            Monthly
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="leave_carried_quarterly"
                                                            name="leave_carried_quarterly"
                                                            value="quarterly"
                                                            checked={
                                                                formData?.balanceCarriedForward === "quarterly"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "balanceCarriedForward",
                                                                    "quarterly"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_carried_quarterly"
                                                            className="form-check-label"
                                                        >
                                                            Quarterly
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_carried_yearly"
                                                            name="leave_carried_yearly"
                                                            value="yearly"
                                                            checked={
                                                                formData?.balanceCarriedForward === "yearly"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "balanceCarriedForward",
                                                                    "yearly"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_carried_yearly"
                                                            className="form-check-label"
                                                        >
                                                            Yearly
                                                        </label>
                                                    </div> */}
                                                    {/* balance Carried ForwardSetting */}
                                                    {/* {formData?.balanceCarriedForward && ( */}
                                                    <div ref={balanceCarriedForwardToBeRef} className="">
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="leave_carried_daily1"
                                                                name="leave_carried_daily1"
                                                                value="1"
                                                                disabled={!formData?.leaveType}
                                                                checked={
                                                                    formData?.balanceCarriedForwardToBe === "1"
                                                                }
                                                                onChange={() =>
                                                                    handleFormData(
                                                                        "balanceCarriedForwardToBe",
                                                                        "1"
                                                                    )
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="leave_carried_daily1"
                                                                className="form-check-label"
                                                            >
                                                                No Carry Forward
                                                            </label>
                                                        </div>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="leave_carried_monthly2"
                                                                name="leave_carried_monthly2"
                                                                disabled={!formData?.leaveType}
                                                                value="2"
                                                                checked={
                                                                    formData?.balanceCarriedForwardToBe === "2"
                                                                }
                                                                onChange={() =>
                                                                    handleFormData(
                                                                        "balanceCarriedForwardToBe",
                                                                        "2"
                                                                    )
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="leave_carried_monthly2"
                                                                className="form-check-label"
                                                            >
                                                                Carry Forward with No Limit
                                                            </label>
                                                        </div>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="leave_carried_quarterly3"
                                                                name="leave_carried_quarterly3"
                                                                disabled={!formData?.leaveType}
                                                                value="3"
                                                                checked={
                                                                    formData?.balanceCarriedForwardToBe === "3"
                                                                }
                                                                onChange={() =>
                                                                    handleFormData(
                                                                        "balanceCarriedForwardToBe",
                                                                        "3"
                                                                    )
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="leave_carried_quarterly3"
                                                                className="form-check-label"
                                                            >
                                                                Carry Forward with Max CAP
                                                            </label>
                                                        </div>
                                                        {formData?.balanceCarriedForwardToBe === '3' && (
                                                            <div className=" mx-4">
                                                                <div className="">
                                                                    <label
                                                                        htmlFor="balance_cf_number"
                                                                        className="form-label"
                                                                    >
                                                                        Max Cap:
                                                                    </label>
                                                                    <div className="w-100 mt-1">
                                                                        <input
                                                                            type="text"
                                                                            id="balance_cf_number"
                                                                            name="balance_cf_number"
                                                                            placeholder="In Numbers"
                                                                            ref={balanceCarriedForwardNumberRef}
                                                                            disabled={!formData?.leaveType}
                                                                            value={formData?.balanceCarriedForwardNumber}
                                                                            onChange={(e) => {
                                                                                // handleFormData(
                                                                                //     "negativeLeaveToBe",
                                                                                //     e.target.value
                                                                                // );
                                                                                handleNumbers(
                                                                                    "balanceCarriedForwardNumber",
                                                                                    e.target.value
                                                                                );
                                                                            }
                                                                            }
                                                                            className={`form-control w-100 ${errors?.balanceCarriedForwardNumber ? "is-invalid" : ""}`}
                                                                        />
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className=" text-danger mx-4">{formData?.balanceCarriedForwardToBe==="3" && errors?.balanceCarriedForwardNumber ? errors?.balanceCarriedForwardNumber : null}</div>
                                                        <div className=" text-danger mx-4">{errors?.balanceCarriedForwardToBe ? errors?.balanceCarriedForwardToBe : null}</div>
                                                    </div>
                                                    {/* )} */}
                                                </div>
                                                {/* How do you want to accrue leave balance? */}
                                                <div ref={accrualFromRef} className="col-md-6 mt-4 mb-4 settings-section">
                                                    <label>
                                                        How do you want to accrue leave balance?
                                                    </label>
                                                    <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="accruals_from_auto"
                                                            name="accruals_from_auto"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.accrualFrom === "1"}
                                                            onChange={() =>
                                                                handleFormData("accrualFrom", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="accruals_from_auto"
                                                            className="form-check-label"
                                                        >
                                                            Auto
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="accruals_from_manual"
                                                            name="accruals_from_manual"
                                                            disabled={!formData?.leaveType}
                                                            value="2"
                                                            checked={formData?.accrualFrom === "2"}
                                                            onChange={() =>
                                                                handleFormData("accrualFrom", "2")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="accruals_from_manual"
                                                            className="form-check-label"
                                                        >
                                                            Excel
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="accruals_from_payroll"
                                                            name="accruals_from_payroll"
                                                            disabled={!formData?.leaveType}
                                                            value="3"
                                                            checked={formData?.accrualFrom === "3"}
                                                            onChange={() =>
                                                                handleFormData("accrualFrom", "3")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="accruals_from_payroll"
                                                            className="form-check-label"
                                                        >
                                                            Payroll
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger mx-1">{errors?.accrualFrom ? errors?.accrualFrom : null}</div>
                                                </div>
                                                {/* How do you want to run the leave accruals? */}
                                                <div ref={leaveAccrualRef} className="col-md-6 mt-4 mb-4 settings-section">
                                                    <label>
                                                        How do you want to run the leave accruals?
                                                    </label>
                                                    <br />
                                                    {/* <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="leave_accruals_daily"
                                                            name="leave_accruals_daily"
                                                            value="daily"
                                                            checked={formData?.leaveAccrual === "daily"}
                                                            onChange={() =>
                                                                handleFormData("leaveAccrual", "daily")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_accruals_daily"
                                                            className="form-check-label"
                                                        >
                                                            Daily
                                                        </label>
                                                    </div> */}
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_accruals_monthly"
                                                            name="leave_accruals_monthly"
                                                            disabled={!formData?.leaveType}
                                                            value="monthly"
                                                            checked={formData?.leaveAccrual === "monthly"}
                                                            onChange={() =>
                                                                handleFormData("leaveAccrual", "monthly")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_accruals_monthly"
                                                            className="form-check-label"
                                                        >
                                                            Monthly
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="leave_accruals_quarterly"
                                                            name="leave_accruals_quarterly"
                                                            disabled={!formData?.leaveType}
                                                            value="quarterly"
                                                            checked={formData?.leaveAccrual === "quarterly"}
                                                            onChange={() =>
                                                                handleFormData("leaveAccrual", "quarterly")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_accruals_quarterly"
                                                            className="form-check-label"
                                                        >
                                                            Quarterly
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_accruals_yearly"
                                                            name="leave_accruals_yearly"
                                                            disabled={!formData?.leaveType}
                                                            value="yearly"
                                                            checked={formData?.leaveAccrual === "yearly"}
                                                            onChange={() =>
                                                                handleFormData("leaveAccrual", "yearly")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_accruals_yearly"
                                                            className="form-check-label"
                                                        >
                                                            Yearly
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger mx-1">{errors?.leaveAccrual ? errors?.leaveAccrual : null}</div>
                                                    {/* Date the leaves to be accrued Setting */}
                                                    {/* {formData?.leaveAccrual && (
                                                        <div className="mx-4 mt-3">
                                                            <label>Which date the leaves to be accrued</label>
                                                            <br />
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id={
                                                                        formData?.leaveAccrual === "daily"
                                                                            ? "start_or_end_of_day1"
                                                                            : formData?.leaveAccrual === "monthly"
                                                                                ? "first_or_last_day_of_month1"
                                                                                : formData?.leaveAccrual === "quarterly"
                                                                                    ? "leave_accruals_quarterly1"
                                                                                    : "leave_accruals_yearly1"
                                                                    }
                                                                    name={
                                                                        formData?.leaveAccrual === "daily"
                                                                            ? "start_or_end_of_day1"
                                                                            : formData?.leaveAccrual === "monthly"
                                                                                ? "first_or_last_day_of_month1"
                                                                                : formData?.leaveAccrual === "quarterly"
                                                                                    ? "leave_accruals_quarterly1"
                                                                                    : "leave_accruals_yearly1"
                                                                    }
                                                                    value="1"
                                                                    checked={formData?.dayOfLeaveAccrual === "1"}
                                                                    onChange={() => {
                                                                        handleFormData("dayOfLeaveAccrual", "1");
                                                                    }
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label
                                                                    htmlFor={
                                                                        formData?.leaveAccrual === "daily"
                                                                            ? "start_or_end_of_day1"
                                                                            : formData?.leaveAccrual === "monthly"
                                                                                ? "first_or_last_day_of_month1"
                                                                                : formData?.leaveAccrual === "quarterly"
                                                                                    ? "leave_accruals_quarterly1"
                                                                                    : "leave_accruals_yearly1"
                                                                    }
                                                                    className="form-check-label"
                                                                >
                                                                    {formData?.leaveAccrual === "daily"
                                                                        ? "Beginning of the Day"
                                                                        : formData?.leaveAccrual === "monthly"
                                                                            ? "1ST day of the month"
                                                                            : formData?.leaveAccrual === "quarterly"
                                                                                ? "1 Day of the Quarter"
                                                                                : "1st day of the Year"}
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id={
                                                                        formData?.leaveAccrual === "daily"
                                                                            ? "start_or_end_of_day2"
                                                                            : formData?.leaveAccrual === "monthly"
                                                                                ? "first_or_last_day_of_month2"
                                                                                : formData?.leaveAccrual === "quarterly"
                                                                                    ? "leave_accruals_quarterly2"
                                                                                    : "leave_accruals_yearly2"
                                                                    }
                                                                    name={
                                                                        formData?.leaveAccrual === "daily"
                                                                            ? "start_or_end_of_day2"
                                                                            : formData?.leaveAccrual === "monthly"
                                                                                ? "first_or_last_day_of_month2"
                                                                                : formData?.leaveAccrual === "quarterly"
                                                                                    ? "leave_accruals_quarterly2"
                                                                                    : "leave_accruals_yearly2"
                                                                    }
                                                                    value="1"
                                                                    checked={formData?.dayOfLeaveAccrual === "2"}
                                                                    onChange={() => {
                                                                        handleFormData("dayOfLeaveAccrual", "2");
                                                                    }
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label
                                                                    htmlFor={
                                                                        formData?.leaveAccrual === "daily"
                                                                            ? "start_or_end_of_day2"
                                                                            : formData?.leaveAccrual === "monthly"
                                                                                ? "first_or_last_day_of_month2"
                                                                                : formData?.leaveAccrual === "quarterly"
                                                                                    ? "leave_accruals_quarterly2"
                                                                                    : "leave_accruals_yearly2"
                                                                    }
                                                                    className="form-check-label"
                                                                >
                                                                    {formData?.leaveAccrual === "daily"
                                                                        ? "At the end of Day"
                                                                        : formData?.leaveAccrual === "monthly"
                                                                            ? "Last day of Month"
                                                                            : formData?.leaveAccrual === "quarterly"
                                                                                ? "Last day of Quarter"
                                                                                : "Last day of the Year"}{" "}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )} */}
                                                </div>
                                                {/* leave accrual nearest to 0.5 Unit setting */}
                                                <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Should we round of the leave accrual nearest to 0.5 Unit</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="nearest_accrual_unit_yes"
                                                            name="nearest_accrual_unit"
                                                            value="1"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.nearestAccrualUnit === "1"}
                                                            onChange={() => handleFormData("nearestAccrualUnit", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="nearest_accrual_unit_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="nearest_accrual_unit_no"
                                                            name="nearest_accrual_unit"
                                                            value="0"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.nearestAccrualUnit === "0"}
                                                            onChange={() => handleFormData("nearestAccrualUnit", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="nearest_accrual_unit_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* leave is a Paid Leave Setting */}
                                                <div ref={paidLeaveRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Is this type of leave is a Paid Leave?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="paid_leave_yes"
                                                            name="paid_leave"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.paidLeave === "1"}
                                                            onChange={() => handleFormData("paidLeave", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="paid_leave_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="paid_leave_no"
                                                            name="paid_leave"
                                                            disabled={!formData?.leaveType}
                                                            value="0"
                                                            checked={formData?.paidLeave === "0"}
                                                            onChange={() => handleFormData("paidLeave", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="paid_leave_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger mx-1">{errors?.paidLeave ? errors?.paidLeave : null}</div>
                                                </div>
                                                {/* What if the leave balance number is exceeding the maximum capping of the leaves? */}
                                                {formData?.balanceCarriedForwardToBe === "3" && (
                                                    <div ref={exceedMaxCapLeaveRef} className="col-md-6 mt-4 mb-4 settings-section">
                                                        <label>
                                                            What if the leave balance number is exceeding the
                                                            maximum capping of the leaves?
                                                        </label>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                type="radio"
                                                                id="leave_leave_lapsed1"
                                                                name="leave_leave_lapsed"
                                                                value="1"
                                                                checked={formData?.exceedMaxCapLeave === "1"}
                                                                onChange={() =>
                                                                    handleFormData("exceedMaxCapLeave", "1")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="leave_leave_lapsed1"
                                                                className="form-check-label"
                                                            >
                                                                leaves will be lapsed
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline mt-2">
                                                            <input
                                                                type="radio"
                                                                id="leave_leave_encashed2"
                                                                name="leave_leave_encashed"
                                                                value="2"
                                                                disabled={formData?.paidLeave === "0"}
                                                                checked={formData?.exceedMaxCapLeave === "2"}
                                                                onChange={() =>
                                                                    handleFormData("exceedMaxCapLeave", "2")
                                                                }
                                                                className="form-check-input"
                                                            />
                                                            <label
                                                                htmlFor="leave_leave_encashed2"
                                                                className="form-check-label"
                                                            >
                                                                leaves will be encashed
                                                            </label>
                                                        </div>
                                                        {/* excess leaves to be encashed */}
                                                        {formData?.exceedMaxCapLeave === "2" && (
                                                            <div ref={excessLeaveToBeRef} className="mx-4 mt-1">
                                                                <label>
                                                                    How the excess leaves to be encashed?
                                                                </label>
                                                                <br />
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="excess_leaves_encashed11"
                                                                        name="excess_leaves_encashed11"
                                                                        value="1"
                                                                        checked={formData?.excessLeaveToBe === "1"}
                                                                        onChange={() =>
                                                                            handleFormData("excessLeaveToBe", "1")
                                                                        }
                                                                        className="form-check-input"
                                                                    />
                                                                    <label
                                                                        htmlFor="excess_leaves_encashed11"
                                                                        className="form-check-label"
                                                                    >
                                                                        Monthly
                                                                    </label>
                                                                </div>{" "}
                                                                <br />
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="excess_leaves_encashed22"
                                                                        name="excess_leaves_encashed22"
                                                                        value="2"
                                                                        checked={formData?.excessLeaveToBe === "2"}
                                                                        onChange={() =>
                                                                            handleFormData("excessLeaveToBe", "2")
                                                                        }
                                                                        className="form-check-input"
                                                                    />
                                                                    <label
                                                                        htmlFor="excess_leaves_encashed22"
                                                                        className="form-check-label"
                                                                    >
                                                                        Yearly
                                                                    </label>
                                                                </div>{" "}
                                                                <br />
                                                                {/* <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="excess_leaves_encashed3"
                                                                    name="excess_leaves_encashed3"
                                                                    value="3"
                                                                    checked={formData?.excessLeaveToBe === '3'}
                                                                    onChange={() => handleFormData('excessLeaveToBe', '3')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="excess_leaves_encashed3" className="form-check-label">Carry Forward with Limit to max cap</label>
                                                            </div> */}
                                                            </div>
                                                        )}
                                                        <div className=" text-danger mx-1">{formData?.exceedMaxCapLeave === "2" && errors?.excessLeaveToBe ? errors?.excessLeaveToBe : null}</div>
                                                        <div className=" text-danger mx-1">{errors?.exceedMaxCapLeave ? errors?.exceedMaxCapLeave : null}</div>
                                                    </div>
                                                )}
                                                {/* Is this type of leave will be encashed during F&F?  */}
                                                <div ref={encashed_leave_on_fnfRef} className="col-md-6 mt-4 mb-4 settings-section">
                                                    <label>
                                                        Is this type of leave will be encashed during F&F?
                                                    </label>
                                                    <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="encashed_leave_on_fnf1"
                                                            name="encashed_leave_on_fnf"
                                                            value="1"
                                                            disabled={formData?.paidLeave === "0" || !formData?.leaveType}
                                                            checked={formData?.encashed_leave_on_fnf === "1"}
                                                            onChange={() =>
                                                                handleFormData("encashed_leave_on_fnf", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="encashed_leave_on_fnf1"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="encashed_leave_on_fnf0"
                                                            name="encashed_leave_on_fnf"
                                                            value="0"
                                                            disabled={formData?.paidLeave === "0" || !formData?.leaveType}
                                                            checked={formData?.encashed_leave_on_fnf === "0"}
                                                            onChange={() =>
                                                                handleFormData("encashed_leave_on_fnf", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="encashed_leave_on_fnf0"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger mx-4">{errors?.encashed_leave_on_fnf ? errors?.encashed_leave_on_fnf : null}</div>
                                                </div>
                                                {/* Can employee apply this type of leave during notice period?  */}
                                                <div ref={leave_available_in_notice_periodRef} className="col-md-6 mt-4 mb-4 settings-section">
                                                    <label>
                                                        Can employee apply this type of leave during notice period?
                                                    </label>
                                                    <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_available_in_notice_period1"
                                                            name="leave_available_in_notice_period"
                                                            value="1"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.leave_available_in_notice_period === "1"}
                                                            onChange={() =>
                                                                handleFormData("leave_available_in_notice_period", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_available_in_notice_period1"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="leave_available_in_notice_period0"
                                                            name="leave_available_in_notice_period"
                                                            value="0"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.leave_available_in_notice_period === "0"}
                                                            onChange={() =>
                                                                handleFormData("leave_available_in_notice_period", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="leave_available_in_notice_period0"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className=" text-danger mx-4">{errors?.leave_available_in_notice_period ? errors?.leave_available_in_notice_period : null}</div>
                                                </div>
                                               
                                                {/* eligibility of the leave starts */}
                                                <div ref={eligibilityOfLeavesRef} className="col-md-6 mt-4 mb-4 settings-section">
                                                    <label>
                                                        When the eligibility of the leave starts?
                                                    </label>
                                                    <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="eligibility_at_doj"
                                                            name="eligibility_at_doj"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.eligibilityOfLeaves === "1"}
                                                            onChange={() =>
                                                                handleFormData("eligibilityOfLeaves", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="eligibility_at_doj"
                                                            className="form-check-label"
                                                        >
                                                            At Date Of Joining
                                                        </label>
                                                    </div> <br />
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="eligibility_at_confirmation_date_status"
                                                            name="eligibility_at_confirmation_date_status"
                                                            disabled={!formData?.leaveType}
                                                            value="2"
                                                            checked={formData?.eligibilityOfLeaves === "2"}
                                                            onChange={() =>
                                                                handleFormData("eligibilityOfLeaves", "2")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="eligibility_at_confirmation_date_status"
                                                            className="form-check-label"
                                                        >
                                                            At Confirmation Date Status
                                                        </label>
                                                    </div> <br />
                                                    {formData?.eligibilityOfLeaves === "2" && (
                                                        <>
                                                            <div ref={eligibilityOfAccrueLeavesRef} className="mx-4 mt-1 ">
                                                                <div>
                                                                    <label>
                                                                        How do you want to accrue leave for an
                                                                        employee
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="eligibility_of_accrue_leave_yes"
                                                                        name="eligibility_of_accrue_leave"
                                                                        disabled={!formData?.leaveType}
                                                                        value="1"
                                                                        checked={formData?.eligibilityOfAccrueLeaves === "1"}
                                                                        onChange={() =>
                                                                            handleFormData("eligibilityOfAccrueLeaves", "1")
                                                                        }
                                                                        className="form-check-input"
                                                                    />
                                                                    <label
                                                                        htmlFor="eligibility_of_accrue_leave_yes"
                                                                        className="form-check-label"
                                                                    >
                                                                        The Accrued leave during the Probation Period
                                                                        to be added in Leave Balance once employee is
                                                                        marked Confirmed
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="eligibility_of_accrue_leave_no"
                                                                        name="eligibility_of_accrue_leave"
                                                                        value="2"
                                                                        checked={formData?.eligibilityOfAccrueLeaves === "2"}
                                                                        onChange={() =>
                                                                            handleFormData("eligibilityOfAccrueLeaves", "2")
                                                                        }
                                                                        className="form-check-input"
                                                                    />
                                                                    <label
                                                                        htmlFor="eligibility_of_accrue_leave_no"
                                                                        className="form-check-label"
                                                                    >
                                                                        No Accrual of Leaves till an employee status
                                                                        is changed as confirmed.
                                                                    </label>
                                                                </div>
                                                            </div> <br />
                                                        </>
                                                    )}
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="eligibility_at_define_period"
                                                            name="eligibility_at_define_period"
                                                            disabled={!formData?.leaveType}
                                                            value="3"
                                                            checked={formData?.eligibilityOfLeaves === "3"}
                                                            onChange={() =>
                                                                handleFormData("eligibilityOfLeaves", "3")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="eligibility_at_define_period"
                                                            className="form-check-label"
                                                        >
                                                            At Defined Period
                                                        </label>
                                                    </div>
                                                    {/* excess leaves to be encashed */}
                                                    {formData?.eligibilityOfLeaves === "3" && (
                                                        <div className="mx-4 mt-3">
                                                            <div ref={leaveApplicableAfterRef} className="">
                                                                <label
                                                                    htmlFor="leave_applicable_after"
                                                                    className="form-label"
                                                                >
                                                                    {" "}
                                                                    Leave Applicable After:
                                                                </label>
                                                                <Select
                                                                    id="leave_applicable_after"
                                                                    name="leave_applicable_after"
                                                                    className={errors?.leaveApplicableAfter ? 'select-error' : ''}
                                                                    classNamePrefix="react-select"
                                                                    value={monthOptions?.find(
                                                                        (val) =>
                                                                            val.value ===
                                                                            formData?.leaveApplicableAfter
                                                                    )}
                                                                    onChange={(selectedOption) =>
                                                                        handleFormData(
                                                                            "leaveApplicableAfter",
                                                                            selectedOption?.value
                                                                        )
                                                                    }
                                                                    options={monthOptions}
                                                                    placeholder="Select Your Leave Applicable After"
                                                                />
                                                                <div className=" text-danger">{errors?.leaveApplicableAfter ? errors?.leaveApplicableAfter : null}</div>
                                                            </div>
                                                            <div ref={eligibilityOfAccrueLeavesRef} className="mx-4 mt-3 ">
                                                                <div>
                                                                    <label>
                                                                        How do you want to accrue leave for an
                                                                        employee
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="eligibility_of_accrue_leave_yes"
                                                                        name="eligibility_of_accrue_leave"
                                                                        value="1"
                                                                        checked={formData?.eligibilityOfAccrueLeaves === "1"}
                                                                        onChange={() =>
                                                                            handleFormData("eligibilityOfAccrueLeaves", "1")
                                                                        }
                                                                        className="form-check-input"
                                                                    />
                                                                    <label
                                                                        htmlFor="eligibility_of_accrue_leave_yes"
                                                                        className="form-check-label"
                                                                    >
                                                                        The Accrued leave during the Probation Period
                                                                        to be added in Leave Balance once employee is
                                                                        marked Confirmed
                                                                    </label>
                                                                </div>
                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        type="radio"
                                                                        id="eligibility_of_accrue_leave_no"
                                                                        name="eligibility_of_accrue_leave"
                                                                        value="2"
                                                                        checked={formData?.eligibilityOfAccrueLeaves === "2"}
                                                                        onChange={() =>
                                                                            handleFormData("eligibilityOfAccrueLeaves", "2")
                                                                        }
                                                                        className="form-check-input"
                                                                    />
                                                                    <label
                                                                        htmlFor="eligibility_of_accrue_leave_no"
                                                                        className="form-check-label"
                                                                    >
                                                                        No Accrual of Leaves till an employee status
                                                                        is changed as confirmed.
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className=" text-danger mx-4">{formData?.eligibilityOfLeaves && errors?.eligibilityOfAccrueLeaves ? errors?.eligibilityOfAccrueLeaves : null}</div>
                                                    <div className=" text-danger mx-4">{errors?.eligibilityOfLeaves ? errors?.eligibilityOfLeaves : null}</div>
                                                </div>
                                                {/* max cap Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>What if accrual of the leaves is exceeding the max cap for type of leave for the year, before the end of year end</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_yes"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="yes"
                                                            // checked={formData?.adminApplyLeaveBehalfEmployee === "yes"}
                                                            // onChange={() => handleFormData("admin_apply_leave_behalf_employee", "yes")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_no"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="no"
                                                            // checked={formData?.adminApplyLeaveBehalfEmployee === "no"}
                                                            // onChange={() => handleFormData("admin_apply_leave_behalf_employee", "no")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_no" className="form-check-label">No</label>
                                                    </div>
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>What if accrual of the leaves is exceeding the max cap for type of leave for the year, before the end of year end</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_yes"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="yes"
                                                            // checked={formData?.adminApplyLeaveBehalfEmployee === "yes"}
                                                            // onChange={() => handleFormData("admin_apply_leave_behalf_employee", "yes")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_no"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="no"
                                                            // checked={formData?.adminApplyLeaveBehalfEmployee === "no"}
                                                            // onChange={() => handleFormData("admin_apply_leave_behalf_employee", "no")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                {/* Negative Leave Balance */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            Are employees allowed to have Negative Leave
                                                            Balance
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="negative_leave_yes"
                                                            name="negative_leave"
                                                            value="1"
                                                            checked={formData?.negativeLeave === "1"}
                                                            onChange={() =>
                                                                handleFormData("negativeLeave", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="negative_leave_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="negative_leave_no"
                                                            name="negative_leave"
                                                            value="0"
                                                            checked={formData?.negativeLeave === "0"}
                                                            onChange={() =>
                                                                handleFormData("negativeLeave", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="negative_leave_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    {formData?.negativeLeave === "1" && (
                                                        <div className=" mx-4 mt-3">
                                                            <div className="">
                                                                <label
                                                                    htmlFor="negative_leave_to_be"
                                                                    className="form-label"
                                                                >
                                                                    Negative Leave Balance:
                                                                </label>
                                                                <div className="w-100 mt-2">
                                                                    <input
                                                                        type="text"
                                                                        id="negative_leave_to_be"
                                                                        name="negative_leave_to_be"
                                                                        placeholder="In Numbers"
                                                                        value={formData?.negativeLeaveToBe}
                                                                        onChange={(e) => {

                                                                            // handleFormData(
                                                                            //     "negativeLeaveToBe",
                                                                            //     e.target.value
                                                                            // );
                                                                            handleNumbers(
                                                                                "negativeLeaveToBe",
                                                                                e.target.value
                                                                            );
                                                                        }
                                                                        }
                                                                        className="form-control w-100"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div> */}
                                                {/* apply leave for Weekly Off or for National Holidays Setting */}
                                                {/* this is reserve for phase 2 , this will be used in case of flexible holiday */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Can Employee apply this type of leave for Weekly Off or
                                                            for National Holidays</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="apply_leave_on_weekly_off_or_holiday_yes"
                                                            name="apply_leave_on_weekly_off_or_holiday"
                                                            value="1"
                                                            checked={formData?.applyLeaveOnWeeklyOffOrHoliday === "1"}
                                                            onChange={() => handleFormData("applyLeaveOnWeeklyOffOrHoliday", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="apply_leave_on_weekly_off_or_holiday_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="apply_leave_on_weekly_off_or_holiday_no"
                                                            name="apply_leave_on_weekly_off_or_holiday"
                                                            value="0"
                                                            checked={formData?.applyLeaveOnWeeklyOffOrHoliday === "0"}
                                                            onChange={() => handleFormData("applyLeaveOnWeeklyOffOrHoliday", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="apply_leave_on_weekly_off_or_holiday_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                {/* pro-rate the 1st month leaves setting */}
                                                <div ref={cutOffProRateRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>How to pro-rate the 1st month leaves to New Joined
                                                            Employee </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="cutOffProRate_yes"
                                                            name="cutOffProRate"
                                                            value="1"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.cutOffProRate === "1"}
                                                            onChange={() => handleFormData("cutOffProRate", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="cutOffProRate_yes" className="form-check-label">Fixed Cut Off date for the Accrual </label>
                                                        {formData?.cutOffProRate === "1" && (
                                                            <div ref={fixCutOffProRateRef} className="w-100 mx-4 mt-2">
                                                                <input
                                                                    type="text"
                                                                    id="fixCutOffProRate_yes"
                                                                    name="fixCutOffProRate"
                                                                    placeholder='In days'
                                                                    disabled={!formData?.leaveType}
                                                                    value={formData?.fixCutOffProRate}
                                                                    onChange={(e) => handleNumbers("fixCutOffProRate", e.target.value)}
                                                                    className="form-control w-100"
                                                                />
                                                                {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                                <div className="text-danger">{errors?.fixCutOffProRate ? errors?.fixCutOffProRate : null}</div>
                                                            </div>
                                                        )}
                                                    </div> <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="cutOffProRate_no"
                                                            name="cutOffProRate"
                                                            value="2"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.cutOffProRate === "2"}
                                                            onChange={() => handleNumbers("cutOffProRate", "2")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="cutOffProRate_no" className="form-check-label">No Cut Off</label>
                                                        <br />
                                                        <small className=' text-muted'>(To be calculated on the basis of no of day present in the 1st Month.)</small>
                                                    </div>
                                                    <div className="text-danger">{errors?.cutOffProRate ? errors?.cutOffProRate : null}</div>
                                                </div>
                                                {/* How many days prior should an employee apply for leave? */}
                                                <div ref={daysBeforeLeaveApplyRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                        How many days prior should an employee apply for leave?
                                                        </label>
                                                    </div>
                                                    <div className="w-100 mt-2">
                                                        <input
                                                            type="text"
                                                            id="daysBeforeLeaveApply_yes"
                                                            name="daysBeforeLeaveApply"
                                                            disabled={!formData?.leaveType}
                                                            ref={daysBeforeLeaveApplyRef}
                                                            placeholder="In days"
                                                            value={formData?.daysBeforeLeaveApply}
                                                            onChange={(e) =>
                                                                handleNumbers(
                                                                    "daysBeforeLeaveApply",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className={`form-control w-100 ${errors?.daysBeforeLeaveApply ? "is-invalid" : ""}`}
                                                        />
                                                        <div className="text-danger">{errors?.daysBeforeLeaveApply ? errors?.daysBeforeLeaveApply : null}</div>
                                                    </div>
                                                </div>
                                                {/* Future Leaves  Setting */}
                                                <div ref={futureLeaveRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Can Employee Apply Future Leaves? </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="future_leaves_yes"
                                                            name="future_leaves"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.futureLeave === "1"}
                                                            onChange={() =>
                                                                handleFormData("futureLeave", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="future_leaves_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="future_leaves_no"
                                                            name="future_leaves"
                                                            disabled={!formData?.leaveType}
                                                            value="0"
                                                            checked={formData?.futureLeave === "0"}
                                                            onChange={() =>
                                                                handleFormData("futureLeave", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="future_leaves_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    {formData?.futureLeave === "1" && (
                                                        <div ref={futureDaysToApplyLeaveRef} className="mx-4 mt-1 ">
                                                            <div>
                                                                <label>
                                                                    How many days before an employee can apply
                                                                    leave?
                                                                </label>
                                                            </div>
                                                            <div className="w-100">
                                                                <input
                                                                    type="text"
                                                                    id="future_days_leave_to_apply_yes"
                                                                    name="future_days_leave_to_apply"
                                                                    placeholder="In days"
                                                                    value={formData?.futureDaysToApplyLeave}
                                                                    onChange={(e) =>
                                                                        handleFormData(
                                                                            "futureDaysToApplyLeave",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100 ${errors?.futureDaysToApplyLeave ? "is-invalid" : ""}`}
                                                                />
                                                                {/* <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label> */}
                                                            </div>
                                                            <div className=" text-danger">{errors?.futureDaysToApplyLeave ? errors?.futureDaysToApplyLeave : null}</div>
                                                        </div>
                                                    )}
                                                    <div className=" text-danger">{errors?.futureLeave ? errors?.futureLeave : null}</div>
                                                </div>
                                                {/* Back Leaves  Setting */}
                                                <div ref={backDateLeaveRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Can an Employee apply Back dated leaves for this type of leave</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="back_date_leaves_yes"
                                                            name="back_date_leaves_yes"
                                                            value="1"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.backDateLeave === "1"}
                                                            onChange={() =>
                                                                handleFormData("backDateLeave", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label  htmlFor="back_date_leaves_yes" className="form-check-label">Yes</label>
                                                            {/* Yes {formData?.backDateLeave === "1" && (<> <small className=" text-danger">(Leave cannot be applied for dates in months where payroll is already processed.)</small>  </>)} */}
                                                        
                                                    </div>
                                                        {/* {formData?.backDateLeave === "1" && (<> <small className=" text-danger">(Employee can apply leave till start of last payroll cycle)</small>  </>)} */}
                                                        
                                                    {/* </div>  {formData?.backDateLeave === "1" && (<br />)} */}
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="back_date_leaves_no"
                                                            name="back_date_leaves"
                                                            value="0"
                                                            disabled={!formData?.leaveType}
                                                            checked={formData?.backDateLeave === "0"}
                                                            className="form-check-input"
                                                            onChange={() =>
                                                                handleFormData("backDateLeave", "0")
                                                            }/>
                                                        <label htmlFor="back_date_leaves_no" className="form-check-label">
                                                            No
                                                        </label>
                                                    </div>
                                                  
                                                    {formData?.backDateLeave === "1" && (
                                                        <div ref={backDaysToApplyLeaveRef} className="mx-4 ">
                                                            <div>
                                                                <label>How many back days they can apply</label>
                                                            </div>
                                                            <div className="w-100">
                                                                <input
                                                                    type="text"
                                                                    id="back_days_leave_to_apply_yes"
                                                                    name="back_days_leave_to_apply"
                                                                    placeholder="In days"
                                                                    value={formData?.backDaysToApplyLeave}
                                                                    // ref={backDaysToApplyLeaveRef}
                                                                    onChange={(e) =>
                                                                        handleNumbers(
                                                                            "backDaysToApplyLeave",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                    className={`form-control w-100 ${errors?.backDaysToApplyLeave ? "is-invalid" : ""}`}
                                                                    />
                                                            <div className="text-danger">{errors?.backDaysToApplyLeave ? errors?.backDaysToApplyLeave : null}</div>

                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className="text-danger">{errors?.backDateLeave ? errors?.backDateLeave : null}</div>
                                                      {/* {formData?.backDateLeave === "1" && (
                                                        <div className="col-md-6 mt-1 settings-section">
                                                            <label htmlFor="backDaysToApplyLeave" className="form-label">
                                                                Select Payroll Cycle 
                                                            </label>
                                                            <Select
                                                                id="backDaysToApplyLeave"
                                                                name="backDaysToApplyLeave"
                                                                value={payrollCycleOptions?.find(
                                                                    (val) => val?.value === formData?.backDaysToApplyLeave
                                                                )}
                                                                
                                                                onChange={(selectedOption) => {
                                                                    setFormData({
                                                                        ...formData,
                                                                        backDaysToApplyLeave: selectedOption?.value,
                                                                    });
                                                                    // setLeaveTypeId(selectedOption?.value);
                                                                }}
                                                                options={payrollCycleOptions}
                                                                placeholder="Select Cycle"
                                                            />
                                                            <div>{errors?.backDaysToApplyLeave ? errors?.backDaysToApplyLeave : null}</div>
                                                        </div>
                                                    )} */}
                                                    </div>
                                                {/* apply for the leave after Salary Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Do you want to allow Employees to apply for the leave after Salary is processed for that month?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="leave_after_salary_yes"
                                                            name="leave_after_salary"
                                                            value="1"
                                                            checked={formData?.leaveAfterSalary === "1"}
                                                            onChange={() => handleFormData("leaveAfterSalary", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_after_salary_no"
                                                            name="leave_after_salary"
                                                            value="0"
                                                            checked={formData?.leaveAfterSalary === "0"}
                                                            onChange={() => handleFormData("leaveAfterSalary", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="leave_after_salary_no" className="form-check-label">No</label>
                                                    </div>
                                                    {formData?.leaveAfterSalary === "1" && (
                                                        <div className="mx-4 mt-3">
                                                            <label htmlFor="leave_applicable_after" className="form-label">How many days the Leave to be applied?</label>
                                                            <div className="w-100 mt-2">
                                                                <input
                                                                    type="number"
                                                                    id="days_leave_to_apply_yes"
                                                                    name="days_leave_to_apply"
                                                                    placeholder='In days'
                                                                    value={formData?.daysToApplyLeaveAfterSalary}
                                                                    onChange={(e) => handleFormData("daysToApplyLeaveAfterSalary", e.target.value)}
                                                                    className="form-control w-100"
                                                                />                                                            </div>
                                                           
                                                        </div>
                                                    )}
                                                </div> */}
                                                {/*  eligible for encashment Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Is this type of leave being eligible for encashment</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="encashment_yes"
                                                            name="encashment"
                                                            value="yes"
                                                            checked={formData?.encashment === "yes"}
                                                            onChange={() => handleFormData("encashment", "yes")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="encashment_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="encashment_no"
                                                            name="encashment"
                                                            value="no"
                                                            checked={formData?.encashment === "no"}
                                                            onChange={() => handleFormData("encashment", "no")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="encashment_no" className="form-check-label">No</label>
                                                    </div>
                                                    {formData?.encashment === "yes" ?
                                                        <div className="mt-2 ">
                                                            <div>
                                                                <label>how you want to define the eligibility </label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="encashment1"
                                                                    name="encashment"
                                                                    value="1"
                                                                    // checked={formData?.encashment === "1"}
                                                                    // onChange={() => handleFormData("encashment", "1")}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="encashment1" className="form-check-label">At the end of the services through F&F</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="encashment2"
                                                                    name="encashment"
                                                                    value="2"
                                                                    // checked={formData?.encashment === "2"}
                                                                    // onChange={() => handleFormData("encashment", "2")}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="encashment2" className="form-check-label">At the end of Year, while new roll over</label>
                                                            </div>
                                                        </div> : null
                                                    }
                                                </div> */}
                                                {/* Max no. of leaves can be encashed Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Do you want to keep the Max no. of leaves can be encashed</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_yes"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="yes"
                                                            // checked={formData?.adminApplyLeaveBehalfEmployee === "yes"}
                                                            // onChange={() => handleFormData("admin_apply_leave_behalf_employee", "yes")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_yes" className="form-check-label">No Limit (the entire balance leaves to be encashed)</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_no"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="no"
                                                            // checked={formData?.adminApplyLeaveBehalfEmployee === "no"}
                                                            // onChange={() => handleFormData("admin_apply_leave_behalf_employee", "no")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_no" className="form-check-label">Max. Cap for the number of leaves.</label>
                                                    </div>
                                                </div> */}
                                                {/*  Half Day option Setting */}
                                                <div ref={halfDayLeaveRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Do you want to provide Half Day option for this type of leave?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="half_day_leave_yes"
                                                            name="half_day_leave"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.halfDayLeave === "1"}
                                                            onChange={() =>
                                                                handleFormData("halfDayLeave", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="half_day_leave_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="half_day_leave_no"
                                                            name="half_day_leave"
                                                            disabled={!formData?.leaveType}
                                                            value="0"
                                                            checked={formData?.halfDayLeave === "0"}
                                                            onChange={() =>
                                                                handleFormData("halfDayLeave", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="half_day_leave_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className="text-danger">{errors?.halfDayLeave ? errors?.halfDayLeave : null}</div>
                                                </div>
                                                {/* weekly off and holiday Leave Setting */}
                                                <div ref={considerAllDaysAsLeaveRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>If Fixed Holidays / Weekly off falls in between the continuous leave taken, should it be included in the number of days
                                                        <span className="ms-1">
                                                        <TooltipComponent 
                                                        name="If leave is taken between a weekly off and a holiday, then the weekly off and holiday will also be counted as leave days."                                                                     
                                                        position="top"
                                                        >
                                                        <i 
                                                        className="ri-information-line" 
                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                        aria-label="More info"
                                                        ></i>
                                                        </TooltipComponent>
                                                        </span>
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="consider_all_days_as_leave1"
                                                            name="consider_all_days_as_leave1"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.considerAllDaysAsLeave === "1"}
                                                            onChange={() => handleFormData("considerAllDaysAsLeave", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="consider_all_days_as_leave1"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="consider_all_days_as_leave0"
                                                            name="consider_all_days_as_leave0"
                                                            disabled={!formData?.leaveType}
                                                            value="0"
                                                            checked={formData?.considerAllDaysAsLeave === "0"}
                                                            onChange={() => handleFormData("considerAllDaysAsLeave", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="consider_all_days_as_leave0"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className="text-danger">{errors?.considerAllDaysAsLeave ? errors?.considerAllDaysAsLeave : null}</div>
                                                </div>
                                                {formData?.considerAllDaysAsLeave === "0" && (
                                                    <>
                                                        <div className="col-md-6 mt-4 settings-section">
                                                            <div>
                                                                <label>
                                                                    How do you want to consider weekly off if leave is taken in continuation? <br />
                                                                    {/* <small className='text-muted'>{formData?.excludeWeeklyOff === '0' ? '(Weekly off to be considered as Weekly Off)' : ''}</small> */}
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="checkbox"
                                                                    id="exclude_weekly_off"
                                                                    name="exclude_weekly_off"
                                                                    value="1"
                                                                    checked={formData.excludeWeeklyOff !== "0"}
                                                                    onChange={(e) =>
                                                                        handleFormData(
                                                                            "excludeWeeklyOff",
                                                                            e.target.checked ? "1" : "0"
                                                                        )
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="exclude_weekly_off">
                                                                    To Consider Weekly off as Leave
                                                                </label>
                                                            </div>
                                                            {formData?.excludeWeeklyOff !== "0" ?
                                                                <div className="mx-4">
                                                                    {/* <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_weekly_off1"
                                                                            name="exclude_weekly_off"
                                                                            value="1"
                                                                            checked={formData?.excludeWeeklyOff === "1"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeWeeklyOff", "1")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_weekly_off11"
                                                                            className="form-check-label"
                                                                        >
                                                                            if weekly off is immediately followed by Leave taken
                                                                        </label>
                                                                    </div> */}
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_weekly_off1"
                                                                            name="exclude_weekly_off"
                                                                            value="1"
                                                                            checked={formData?.excludeWeeklyOff === "1"}
                                                                            onChange={() => handleFormData("excludeWeeklyOff", "1")}
                                                                            className="form-check-input"
                                                                        />
                                                                        <label htmlFor="exclude_weekly_off1" className="form-check-label d-inline-flex align-items-center">
                                                                            If weekly off is immediately followed by a leave  
                                                                            {/* Tooltip with Info Icon */}
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="If weekly off is followed by a leave then that weekly off is consider as leave"                                                                      position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                   </div>
                                                                    <br />
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_weekly_off2"
                                                                            name="exclude_weekly_off"
                                                                            value="2"
                                                                            checked={formData?.excludeWeeklyOff === "2"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeWeeklyOff", "2")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_weekly_off2"
                                                                            className="form-check-label"
                                                                        >
                                                                            If Leave is taken immediately after the Weekly Off.
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="If leave is taken immediately in the first half of after the weekly off, then that weekly off is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                    </div>{" "}
                                                                    <br />
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_weekly_off3"
                                                                            name="exclude_weekly_off"
                                                                            value="3"
                                                                            checked={formData?.excludeWeeklyOff === "3"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeWeeklyOff", "3")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_weekly_off13"
                                                                            className="form-check-label"
                                                                        >
                                                                            If Leave is taken immediately before OR after the weekly off
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="If leave is taken immediately in the second half before or after the first off the weekly off, then the weekly off is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                    </div> <br />
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_weekly_off4"
                                                                            name="exclude_weekly_off"
                                                                            value="4"
                                                                            checked={formData?.excludeWeeklyOff === "4"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeWeeklyOff", "4")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_weekly_off14"
                                                                            className="form-check-label"
                                                                        >
                                                                            Only When Leave is taken immediately before AND after the Weekly off
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="Only when leave is taken immediately in the second half before the weekly off and after the first half of the weekly off, then that weekly off is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>

                                                                        </label>
                                                                    </div>
                                                                </div> : null
                                                            }
                                                        </div>
                                                        <div className="col-md-6 mt-4 settings-section">
                                                            <div>
                                                                <label>
                                                                    How do you want to consider holiday if leave is taken in continuation? <br />
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline ">
                                                                <input
                                                                    type="checkbox"
                                                                    id="exclude_holiday"
                                                                    name="exclude_holiday"
                                                                    value="1"
                                                                    checked={formData.excludeHoliday !== "0"}
                                                                    onChange={(e) =>
                                                                        handleFormData(
                                                                            "excludeHoliday",
                                                                            e.target.checked ? "1" : "0"
                                                                        )
                                                                    }
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="exclude_holiday">
                                                                    To Consider Holiday as Leave
                                                                </label>
                                                            </div>
                                                            {formData?.excludeHoliday !== "0" && (
                                                                <div className="mx-4">
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_holiday1"
                                                                            name="exclude_holiday"
                                                                            value="1"
                                                                            checked={formData?.excludeHoliday === "1"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeHoliday", "1")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_holiday1"
                                                                            className="form-check-label"
                                                                        >
                                                                            If holiday is immediately followed by Leave taken
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="if leave is applied immediately in the second half before the holiday, then that holiday is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                    </div>{" "}
                                                                    <br />
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_holiday2"
                                                                            name="exclude_holiday"
                                                                            value="2"
                                                                            checked={formData?.excludeHoliday === "2"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeHoliday", "2")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_holiday2"
                                                                            className="form-check-label"
                                                                        >
                                                                            If Leave is taken immediately after the holiday.
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="if leave is applied immediately in the first half after the holiday, then that holiday is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                    </div>{" "}
                                                                    <br />
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_holiday3"
                                                                            name="exclude_holiday"
                                                                            value="3"
                                                                            checked={formData?.excludeHoliday === "3"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeHoliday", "3")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_holiday3"
                                                                            className="form-check-label"
                                                                        >
                                                                            If Leave is taken immediately before OR after the holiday
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="If Leave is taken immediately before OR after the holiday, then that holiday is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check form-check-inline small">
                                                                        <input
                                                                            type="radio"
                                                                            id="exclude_holiday4"
                                                                            name="exclude_holiday"
                                                                            value="4"
                                                                            checked={formData?.excludeHoliday === "4"}
                                                                            onChange={() =>
                                                                                handleFormData("excludeHoliday", "4")
                                                                            }
                                                                            className="form-check-input"
                                                                        />
                                                                        <label
                                                                            htmlFor="exclude_holiday4"
                                                                            className="form-check-label"
                                                                        >
                                                                            Only When Leave is taken immediately before AND after the holiday
                                                                            <span className="ms-1">
                                                                                <TooltipComponent 
                                                                                    name="If Leave is taken immediately before And after the holiday, then that holiday is also considered as leave."
                                                                                    position="top"
                                                                                >
                                                                                    <i 
                                                                                        className="ri-information-line" 
                                                                                        style={{ cursor: "pointer", color: "#007bff" }} 
                                                                                        aria-label="More info"
                                                                                    ></i>
                                                                                </TooltipComponent>
                                                                            </span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                                {/* Minimum Number of consecutive leave Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            Minimum Number of consecutive leave days allowed{" "}
                                                        </label>
                                                    </div>
                                                    <div className="w-100 mt-2">
                                                        <input
                                                            type="text"
                                                            id="minimum_consecutive_leave_days_yes"
                                                            name="minimum_consecutive_leave_days"
                                                            ref={minConsecutiveLeaveDaysRef}
                                                            placeholder="In days"
                                                            value={formData?.minConsecutiveLeaveDays}
                                                            onChange={(e) =>
                                                                handleNumbers(
                                                                    "minConsecutiveLeaveDays",
                                                                    e.target.value
                                                                )
                                                            }
                                                            disabled={!formData?.leaveType}
                                                            className={`form-control w-100 ${errors?.minConsecutiveLeaveDays ? "is-invalid" : ""}`}
                                                        />
                                                    </div>
                                                </div>
                                                {/* Maximum Number of Consecutive Leave Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            Maximum Number of Consecutive Leave days allowed
                                                        </label>
                                                    </div>
                                                    <div className="w-100 mt-2">
                                                        <input
                                                            type="text"
                                                            id="maximum_consecutive_leave_days_yes"
                                                            name="maximum_consecutive_leave_days"
                                                            disabled={!formData?.leaveType}
                                                            ref={maxConsecutiveLeaveDaysRef}
                                                            placeholder="In days"
                                                            value={formData?.maxConsecutiveLeaveDays}
                                                            onChange={(e) =>
                                                                handleNumbers(
                                                                    "maxConsecutiveLeaveDays",
                                                                    e.target.value
                                                                )
                                                            }
                                                            className={`form-control w-100 ${errors?.maxConsecutiveLeaveDays ? "is-invalid" : ""}`}
                                                        />
                                                        <div className="text-danger">{errors?.maxConsecutiveLeaveDays ? errors?.maxConsecutiveLeaveDays : null}</div>
                                                    </div>
                                                </div>
                                                {/* Weekly Off considered as consecutive Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            What if Leave Taken falls between Holiday & Weekly
                                                            Off.
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="separated_weeklyOff_consecutive_1"
                                                            name="separated_weeklyOff_consecutive"
                                                            value="1"
                                                            checked={
                                                                formData?.separatedWeeklyOffOrHolidayConsecutive ===
                                                                "1"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "separatedWeeklyOffOrHolidayConsecutive",
                                                                    "1"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="separated_weeklyOff_consecutive_1"
                                                            className="form-check-label"
                                                        >
                                                            Should prefix and Suffix Holiday or Weekly off to
                                                            considered as Leave
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="separated_weeklyOff_consecutive_2"
                                                            name="separated_weeklyOff_consecutive"
                                                            value="2"
                                                            checked={
                                                                formData?.separatedWeeklyOffOrHolidayConsecutive ===
                                                                "2"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "separatedWeeklyOffOrHolidayConsecutive",
                                                                    "2"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="separated_weeklyOff_consecutive_2"
                                                            className="form-check-label"
                                                        >
                                                            Should only Prefix holiday to be considered as
                                                            Leave along with leave taken day
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="separated_weeklyOff_consecutive_3"
                                                            name="separated_weeklyOff_consecutive"
                                                            value="3"
                                                            checked={
                                                                formData?.separatedWeeklyOffOrHolidayConsecutive ===
                                                                "3"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "separatedWeeklyOffOrHolidayConsecutive",
                                                                    "3"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="separated_weeklyOff_consecutive_3"
                                                            className="form-check-label"
                                                        >
                                                            Should only Suffix holiday to be considered as
                                                            Leave along with the leave taken day.
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="separated_weeklyOff_consecutive_4"
                                                            name="separated_weeklyOff_consecutive"
                                                            value="4"
                                                            checked={
                                                                formData?.separatedWeeklyOffOrHolidayConsecutive ===
                                                                "4"
                                                            }
                                                            onChange={() =>
                                                                handleFormData(
                                                                    "separatedWeeklyOffOrHolidayConsecutive",
                                                                    "4"
                                                                )
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="separated_weeklyOff_consecutive_4"
                                                            className="form-check-label"
                                                        >
                                                            Ignore the holidays and Consider only Leave taken
                                                            day as Leave{" "}
                                                        </label>
                                                    </div>
                                                </div> */}
                                                {/* Holiday considered as consecutive Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Are leave separated by Holiday considered as consecutive</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="separated_holiday_consecutive_yes"
                                                            name="separated_holiday_consecutive"
                                                            value="1"
                                                            checked={formData?.separatedHolidayConsecutive === "1"}
                                                            onChange={() => handleFormData("separatedHolidayConsecutive", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="separated_holiday_consecutive_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="separated_holiday_consecutive_no"
                                                            name="separated_holiday_consecutive"
                                                            value="0"
                                                            checked={formData?.separatedHolidayConsecutive === "0"}
                                                            onChange={() => handleFormData("separatedHolidayConsecutive", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="separated_holiday_consecutive_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                {/* Documents mandatory to be uploaded Setting */}
                                                <div ref={documentMandatoryRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            Is Documents mandatory to be uploaded for this
                                                            type of leave
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="document_mandatory_yes"
                                                            name="document_mandatory"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.documentMandatory === "1"}
                                                            onChange={() =>
                                                                handleFormData("documentMandatory", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="document_mandatory_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="document_mandatory_no"
                                                            name="document_mandatory"
                                                            disabled={!formData?.leaveType}
                                                            value="0"
                                                            checked={formData?.documentMandatory === "0"}
                                                            onChange={() =>
                                                                handleFormData("documentMandatory", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="document_mandatory_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className="text-danger">{errors?.documentMandatory ? errors?.documentMandatory : null}</div>
                                                </div>
                                                {/* make comments Setting */}
                                                <div ref={commentMandatoryRef} className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            Would you like to make comments mandatory while
                                                            applying or cancellation of Leave
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="comment_mandatory_yes"
                                                            name="comment_mandatory"
                                                            disabled={!formData?.leaveType}
                                                            value="1"
                                                            checked={formData?.commentMandatory === "1"}
                                                            onChange={() =>
                                                                handleFormData("commentMandatory", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="comment_mandatory_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="comment_mandatory_no"
                                                            name="comment_mandatory"
                                                            disabled={!formData?.leaveType}
                                                            value="0"
                                                            checked={formData?.commentMandatory === "0"}
                                                            onChange={() =>
                                                                handleFormData("commentMandatory", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="comment_mandatory_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                    <div className="text-danger">{errors?.commentMandatory ? errors?.commentMandatory : null}</div>
                                                </div>
                                                {/* leave is allowed to be clubbed Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>
                                                            Can this type of leave is allowed to be clubbed
                                                            with other type of leave
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="clubbed_leaves_yes"
                                                            name="clubbed_leaves"
                                                            value="1"
                                                            checked={formData?.clubbedLeave === "1"}
                                                            onChange={() =>
                                                                handleFormData("clubbedLeave", "1")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="clubbed_leaves_yes"
                                                            className="form-check-label"
                                                        >
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="clubbed_leaves_no"
                                                            name="clubbed_leaves"
                                                            value="0"
                                                            checked={formData?.clubbedLeave === "0"}
                                                            onChange={() =>
                                                                handleFormData("clubbedLeave", "0")
                                                            }
                                                            className="form-check-input"
                                                        />
                                                        <label
                                                            htmlFor="clubbed_leaves_no"
                                                            className="form-check-label"
                                                        >
                                                            No
                                                        </label>
                                                    </div>
                                                </div> */}
                                                {/* <button type='submit' >Save</button> */}
                                                {/* <div style={{ marginTop: "30px", marginLeft: "Auto" }}>
                                                    {!postLoading ?
                                                        <button
                                                            type="submit"
                                                            disabled={!formData?.leaveType}
                                                            className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                            <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                            {formData?.leave_template_setting_id==0?"Save":"Update"}
                                                        </button> :
                                                        <button
                                                            className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                            <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                            {"Loading..."}
                                                        </button>}
                                                </div> */}
                                               {(decodedData?.includes(3)) && (
                                                <div style={{ marginTop: "30px", marginLeft: "auto" }}>
                                                    {!postLoading ? (
                                                        <button
                                                            type="submit"
                                                            disabled={!formData?.leaveType}
                                                            className="btn btn-primary btn-label waves-effect right waves-light float-right"
                                                        >
                                                            <i className="ri-save-line label-icon align-middle fs-16 ms-2" />{" "}
                                                            {formData?.leave_template_setting_id === 0 ? "Save" : "Update"}
                                                        </button>
                                                    ) : (
                                                        <button className="btn btn-primary btn-label waves-effect right waves-light float-right">
                                                            <i className="ri-save-line label-icon align-middle fs-16 ms-2" />{" "}
                                                            {"Loading..."}
                                                        </button>
                                                    )}
                                                </div>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "90vh" }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LeaveTemplateSettings;
